import React, { useState, useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import { useParams, useNavigate } from 'react-router-dom';
import useModal from 'hooks/useModal';
import ApplicationLayout from 'v3/layouts/Application';
import Button from 'v3/components/Button';
import Text from 'v3/components/Text';
import { usePermission } from 'hooks';
import Section from '../shared/Section';
import Access from '../shared/Access';
import Clients from '../shared/Clients';
import { UserCostCentersManaged } from '../shared/CostCentersManaged';
import Data from '../shared/Data';
import ShippingCompanies from '../shared/ShippingCompanies';
import RegisteredModal from './RegisteredModal';
import Establishments from '../shared/Establishments';
import ProfileSelectionModal from '../shared/Modals/ProfileSelection';
import Beneficiary from '../shared/Beneficiary';
import { useUser } from '../shared/context';
import { handleCreation } from './controller';

export default function UserRegister() {
  usePermission('CADASTRAR_USUARIO', {
    redirect: true,
  });
  const navigate = useNavigate();
  const user = useUser();
  const params = useParams();
  const profileSelectionModal = useModal();
  const [showModal, setShowModal] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [validAdditionalProfiles, setValidAdditionalProfiles] = useState([]);

  useEffect(() => {
    if (!params.clone_id) {
      profileSelectionModal.open();
    }
  }, []);

  useEffect(() => {
    const findAdditionalProfiles = user?.data?.additionalProfiles?.find(profile => profile.name === 'Transportador') || null;
    setValidAdditionalProfiles(findAdditionalProfiles);
  }, [user]);

  return (
    <>
      <ProfileSelectionModal
        isOpen={profileSelectionModal.isOpen}
        onClose={profileSelectionModal.close}
      />
      <ApplicationLayout
        title="Cadastrar usuário"
        RightComponent={
          <>
            <Button
              variant="secondary"
              onClick={() => navigate('/usuarios')}
            >
              <Text weight={500} color="black" type="regular">
                Voltar
              </Text>
            </Button>

            <Button
              variant="success"
              onClick={() => {
                handleCreation(
                  user.data,
                  user.setData,
                  user.setErrors,
                  user.showSnackbar,
                  setLoading,
                  setShowModal,
                  user.fetchUserAudit
                );
              }}
              loading={isLoading}
            >
              <Text weight={500} color="white" type="regular">
                Salvar
              </Text>
            </Button>
          </>
        }
      >
        <RegisteredModal show={showModal} />
        <Row>
          <Col xs={12} md={6}>
            <Section Title="Dados do usuário">
              <Data />
            </Section>
          </Col>
          <Col xs={12} md={6}>
            <Section Title="Dados de acesso">
              <Access />
            </Section>
          </Col>
          {user.data?.profile?.name !== 'Motorista' && (
            <Col xs={12}>
              <ShippingCompanies />
              <Beneficiary />
              <Clients />
              <UserCostCentersManaged />
              <Establishments />
            </Col>
          )}
          {
            validAdditionalProfiles && user.data?.profile?.name === 'Motorista' && (
              <Col xs={12}>
                <ShippingCompanies />
                <Beneficiary />
              </Col>
            )
          }
        </Row>
      </ApplicationLayout>
    </>
  );
}
